/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@/api/fetchClient.js";
import type { PromptControllerGeneratePromptResponseMutationRequest, PromptControllerGeneratePromptResponseMutationResponse, PromptControllerGeneratePromptResponse400, PromptControllerGeneratePromptResponse401, PromptControllerGeneratePromptResponse404, PromptControllerGeneratePromptResponse409, PromptControllerGeneratePromptResponse500 } from "../types/PromptControllerGeneratePromptResponse.js";
import type { Client, RequestConfig, ResponseErrorConfig } from "@/api/fetchClient.js";

function getPromptControllerGeneratePromptResponseUrl() {
  const res = { method: 'POST', url: `/api/prompt` as const }
  return res
}

/**
 * @description Generates a prompt response based on the provided prompt reward request. The API extracts output text contained within <output> tags for clarity, while full output is logged for debugging purposes.
 * @summary Generate Prompt Response
 * {@link /api/prompt}
 */
export async function promptControllerGeneratePromptResponse(data: PromptControllerGeneratePromptResponseMutationRequest, config: Partial<RequestConfig<PromptControllerGeneratePromptResponseMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<PromptControllerGeneratePromptResponseMutationResponse, ResponseErrorConfig<PromptControllerGeneratePromptResponse400 | PromptControllerGeneratePromptResponse401 | PromptControllerGeneratePromptResponse404 | PromptControllerGeneratePromptResponse409 | PromptControllerGeneratePromptResponse500>, PromptControllerGeneratePromptResponseMutationRequest>({ method : "POST", url : getPromptControllerGeneratePromptResponseUrl().url.toString(), data : requestData, ... requestConfig })
  return res.data
}